import { render, staticRenderFns } from "./c_hot_imgs.vue?vue&type=template&id=78ca0fd0&scoped=true&"
import script from "./c_hot_imgs.vue?vue&type=script&lang=js&"
export * from "./c_hot_imgs.vue?vue&type=script&lang=js&"
import style0 from "./c_hot_imgs.vue?vue&type=style&index=0&id=78ca0fd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ca0fd0",
  null
  
)

export default component.exports